import React from "react";
import { useCustomTranslation } from "../../helpers/translateHelpers";

interface Props {
  description?: string;
  className?: string;
}

const EmptyPlaceholder: React.FC<Props> = (props): React.ReactElement => {
  const { t } = useCustomTranslation();

  return (
    <div
      className={`border-gray col-span-full border-1 border-dashed px-6 py-4 text-center text-sm`}
    >
      {props.description ?? t("no_data")}
    </div>
  );
};

export default EmptyPlaceholder;
